import { v7 } from "uuid";
import { localStorage } from "./storage";
export * from "./comparators";
export * from "./types";
export * from "./storage";

export const getClientID = (): string => {
  const clientId = localStorage.getItem("client-id");
  if (clientId !== null) return clientId;

  const newClientId = v7();
  localStorage.setItem("client-id", newClientId);
  return newClientId;
};

export const getJwtToken = () => localStorage.getItem("jwt-token");

export function getImageFromS3(key: string): string {
  return `${import.meta.env.VITE_AWS_S3_BUCKET_URL}/${key}`;
}
